export const BASE_URL = process.env.REACT_APP_BASE_URL ?? ''
export const APP_DEBUG = process.env.REACT_APP_APP_DEBUG ?? true
